import React from "react";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Pillars from "@/components/Pillars";
import Sectors from "@/components/Sectors";
import Portfolio from "@/components/Portfolio";
import Timeline from "@/components/Timeline";
import Vision from "@/components/Vision";
import Partners from "@/components/Partners";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <>
      <main>
        <Hero />
        <About />
        <Pillars />
        <Sectors />
        <Portfolio />
        <Timeline />
        <Vision />
        <Partners />
      </main>
      <Footer />
    </>
  );
}
